/** Labelled library navigation, sharing Office's Home surface. */

import { cardsIcon, gearIcon, houseIcon, folderOpenIcon, Icon, starIcon, trashIcon, usersIcon, type PhIcon } from '../core/icons';
import { RAIL, type HomeView } from './home';

const ICONS: Record<HomeView, PhIcon> = {
  recent: houseIcon,
  owned: houseIcon,
  shared: usersIcon,
  starred: starIcon,
  templates: cardsIcon,
  trash: trashIcon
};

export function Rail({ view, onView, onSettings, onComputer, computer = false }: { view: HomeView; onView: (v: HomeView) => void; onSettings: () => void; onComputer?: () => void; computer?: boolean }) {
  return (
    <nav aria-label="Sections" className="mv-rail hide-sm">
      {RAIL.map((item) => (
        <button
          key={item.value}
          type="button"
          data-key={item.value}
          aria-label={item.label}
          title={item.label}
          aria-current={!computer && view === item.value ? 'page' : undefined}
          className="mv-rail-item"
          onClick={() => onView(item.value)}
        >
          <Icon icon={ICONS[item.value]} size={18} />
          <span>{item.label}</span>
        </button>
      ))}
      {onComputer && <button type="button" className="mv-rail-item" aria-current={computer ? 'page' : undefined} onClick={onComputer}>
        <Icon icon={folderOpenIcon} size={18} /><span>Computer</span>
      </button>}
      {/* Office preferences stay in Office; account management is labeled separately. */}
      <span style={{ flex: 1 }} />
      <button
        type="button"
        onClick={onSettings}
        aria-label="Office settings"
        title="Office settings"
        className="mv-rail-item mv-rail-gear"
      >
        <Icon icon={gearIcon} size={18} /><span>Settings</span>
      </button>
    </nav>
  );
}
